export default {"src":"/_next/static/media/circle-flag-green.d6244329.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};